(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillarborne-bar"] && !Shopify.designMode) return;
  try {
    
function pbTimers(){document.querySelectorAll('.pb-bar[data-deadline]').forEach(bar=>{const timer=bar.querySelector('.pb-timer');if(!timer||timer.dataset.ready)return;const end=Date.parse(bar.dataset.deadline);if(!Number.isFinite(end)||end<=Date.now())return;timer.dataset.ready='1';const tick=()=>{let n=Math.floor((end-Date.now())/1000);if(n<=0){timer.hidden=true;return}const days=Math.floor(n/86400);n%=86400;const h=Math.floor(n/3600),m=Math.floor(n%3600/60),s=n%60;timer.querySelector('strong').textContent=(days?days+'d ':'')+[h,m,s].map(x=>String(x).padStart(2,'0')).join(':');timer.hidden=false;setTimeout(tick,1000)};tick()})}document.addEventListener('DOMContentLoaded',pbTimers);document.addEventListener('shopify:section:load',pbTimers);pbTimers();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillarborne-product"] && !Shopify.designMode) return;
  try {
    
function pbVariantImageSetup(root){root.querySelectorAll('.pb-product__thumb').forEach(button=>{if(button.dataset.pbReady)return;button.dataset.pbReady='1';button.addEventListener('click',()=>{const image=button.closest('.pb-product__image').querySelector('.pb-product__primary-image');if(image){image.srcset='';image.src=button.dataset.image;image.alt=button.dataset.alt||''}})});root.querySelectorAll('.pb-product select').forEach(select=>{if(select.dataset.pbReady)return;select.dataset.pbReady='1';select.addEventListener('change',()=>{const option=select.options[select.selectedIndex];const image=select.closest('.pb-product__inner').querySelector('.pb-product__primary-image');if(image&&option.dataset.image){image.srcset='';image.src=option.dataset.image;image.alt=option.dataset.alt||''}})})}document.addEventListener('DOMContentLoaded',()=>pbVariantImageSetup(document));document.addEventListener('shopify:section:load',event=>pbVariantImageSetup(event.target));pbVariantImageSetup(document);

function pbAddonSetup(root) {
  root.querySelectorAll('.pb-purchase-form').forEach(form => {
    const choices = form.querySelector('.pb-addons');
    if (!choices || form.dataset.addonsReady) return;
    form.dataset.addonsReady = '1';
    choices.hidden = false;
    const panel = form.closest('.pb-product__info');
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('.pb-add-error');
    let widget;
    const selectedExtras = () => Array.from(choices.querySelectorAll('[data-pb-addon]:checked'));
    const updatePrice = () => {
      if (!widget || form.dataset.busy) return;
      const base = widget.pricing().discountedPrice.amount;
      const total = selectedExtras().reduce((sum, input) => sum + Number(input.dataset.price) / 100, base);
      button.textContent = 'Add to cart — ' + new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.Shopify.currency.active || 'USD'}).format(total);
    };
    const connectWidget = component => {
      if (!component || !panel.contains(component) || widget === component || typeof component.items !== 'function') return;
      widget = component;
      panel.classList.add('pb-has-bundle');
      widget.addEventListener('items-changed', updatePrice);
      widget.addEventListener('variant-selected', event => {
        const option = Array.from(form.querySelector('[name="id"]').options).find(option => option.value === String(event.detail.variantId));
        const image = panel.closest('.pb-product__inner').querySelector('.pb-product__primary-image');
        if (option && option.dataset.image && image) { image.srcset = ''; image.src = option.dataset.image; image.alt = option.dataset.alt || ''; }
      });
      widget.addEventListener('add-to-cart-requested', event => addItems(event.detail.items));
      updatePrice();
    };
    const addItems = async lines => {
      if (form.dataset.busy) return;
      form.dataset.busy = '1';
      button.disabled = true;
      button.textContent = 'Adding your set…';
      error.hidden = true;
      try {
        const items = [...lines, ...selectedExtras().map(input => ({id:Number(input.dataset.pbAddon), quantity:1}))];
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Please try again.');
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (err) {
        error.textContent = err.message || 'Unable to add items. Please try again.';
        error.hidden = false;
        delete form.dataset.busy;
        button.disabled = false;
        button.textContent = 'Add to cart';
        updatePrice();
      }
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (widget) {
        if (!widget.validateItemSelection().valid) return;
        addItems(widget.items());
      } else {
        const quantity = Number(form.querySelector('[name="quantity"]').value);
        if (!Number.isInteger(quantity) || quantity < 1) return;
        addItems([{id:Number(form.querySelector('[name="id"]').value), quantity}]);
      }
    });
    choices.addEventListener('change', updatePrice);
    document.addEventListener('kaching-bundles-block-loaded', event => connectWidget(event.detail.component));
    connectWidget(panel.querySelector('kaching-bundles-block'));
  });
}
document.addEventListener('DOMContentLoaded', () => pbAddonSetup(document));
document.addEventListener('shopify:section:load', event => pbAddonSetup(event.target));
pbAddonSetup(document);

  } catch(e) { console.error(e); }
})();
})();
